import { FC } from 'react';

import { RestricoesBuscaSolicitacoesFormulario } from 'business/formulario/RestricoesBuscaSolicitacoesFormulario';
import { SolicitacoesPage } from './SolicitacoesPage';
import { Papel } from 'service/restricao/Papeis';
import { SolicitacoesAction } from 'store/Solicitacoes/Solicitacoes.action';
import { useUsuarioLogado } from 'view/component/UsuarioLogadoContext/UsuarioLogadoContext';


export const MinhasSolicitacoesPage: FC = () => {
  const restricoes = RestricoesBuscaSolicitacoesFormulario.UsuarioComum;
  const usuarioLogado = useUsuarioLogado();
  const gerarAction = () => SolicitacoesAction.lista.iniciarMinhasSolicitacoes(usuarioLogado.idInstitucional);
  
  return <SolicitacoesPage 
    titulo="Minhas Solicitações"
    restricoes={restricoes}
    papel={Papel.UsuarioComum}
    gerarActionBuscaPadrao={gerarAction} 
    isMinhasSolicitacoes={true} />
}
